import { render } from "./CvdTest.vue?vue&type=template&id=23a55ee4"
import script from "./CvdTest.vue?vue&type=script&lang=js"
export * from "./CvdTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__